import axios from 'axios';
import { AlertVariant } from 'components/common/Alerts';
import { NotificationContext } from 'contexts/notification';
import { useContext } from 'react';
import { MultimediaType } from 'utils/constants';
import { useUploadImageOrDocuments } from 'hooks/useApi';

type UploadMedia = {
  patientId?: number,
  multimediaType: MultimediaType,
  dataUrl: string,
  extraName?: string
}

function useMediaUpload() {
  const { notify } = useContext(NotificationContext);
  const { mutateAsync: uploadImageOrDocuments } = useUploadImageOrDocuments();
  const mediaUpload = ({
    patientId = 0,
    multimediaType,
    dataUrl,
    extraName,
  }: UploadMedia) => {
    setTimeout(async () => {
      try {
        await uploadImageOrDocuments({
          patientId,
          multimediaType: String(multimediaType),
          dataURL: dataUrl as string,
          fileName: extraName ?? '',
        });
      } catch (e) {
        if (!axios.isAxiosError(e)) return;
        notify({
          message: `File upload: ${e.message}`,
          variant: AlertVariant.ERROR,
        });
      }
    }, 500);
  };

  return { mediaUpload };
}

export default useMediaUpload;
